import { createSlice } from '@reduxjs/toolkit'
import * as actionTypes from './actionTypes'
import { updateObject } from './utility'

const initialState = { showLoginForm: false, error: null, message: '' }

const slice = createSlice({
  name: 'loginForm',
  initialState,
  reducers: {
    resetLoginForm: () => initialState,
    showLoginForm: (state, { payload }) =>
      updateObject(state, { showLoginForm: true, message: payload?.message ?? '' }),
    closeLoginForm: (state) =>
      updateObject(state, { showLoginForm: false, message: '', error: null }),
    setErrorLoginForm: (state, { payload }) => updateObject(state, { error: payload }),
  },
  extraReducers: (builder) => {
    builder.addCase(actionTypes.SET_ERROR_LOGIN_FORM, (state, action) =>
      updateObject(state, { error: action.payload }),
    )
  },
})

export const { resetLoginForm, showLoginForm, closeLoginForm, setErrorLoginForm } = slice.actions

export default slice
